import "./blockWebsite.styles.css"
import React from 'react';

const BlockWebsite = (props) => {


    return (
        <div className="block-website">
            <div className="block-white-screen"></div>
            <div className="block">
                
                <div className="block-text">השימוש באתר מוגבל למכשירים סלולאריים.</div>
            </div>
        </div>
        
    )
}
export default BlockWebsite;